var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.86983 2.64014C5.86949 3.31906 5.59946 3.97005 5.11915 4.44988C4.63884 4.92971 3.98759 5.19908 3.30866 5.19874C2.62974 5.1984 1.97876 4.92838 1.49893 4.44807C1.0191 3.96776 0.749722 3.31651 0.750061 2.63758C0.750401 1.95866 1.02043 1.30768 1.50074 0.827847C1.98105 0.348016 2.6323 0.0786404 3.31122 0.0789798C3.99015 0.0793193 4.64113 0.349346 5.12096 0.829657C5.60079 1.30997 5.87016 1.96122 5.86983 2.64014ZM5.94662 7.09434H0.826858V23.1192H5.94662V7.09434ZM14.0358 7.09434H8.94168V23.1192H13.9847V14.71C13.9847 10.0254 20.09 9.59022 20.09 14.71V23.1192H25.1457V12.9693C25.1457 5.07203 16.1094 5.36642 13.9847 9.24464L14.0358 7.09434Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.ebbfe150c9248893badf4c72dc8a5532.svg";
export { ForwardRef as ReactComponent };